<rid-mechanic-background />

@let _state = state();

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Basis lezen | Mistlezen" [steps]="sentencess().length" [progress]="step()" />

  <rid-mechanic-content>
    <!-- title -->
    @if (_state.type !== 'REVIEWING') {
      <rid-mechanic-title [title]="'Lees de zinnen hardop voor'" />
    }

    <!-- sentences -->
    @for (input of [sentences()]; track input) {
      <div class="absolute flex flex-col gap-4" animate.leave="anim-fade-out">
        @for (sentence of input; track $index) {
          <rid-sentence
            #sentences
            [sentence]="sentence"
            animate.enter="anim-fade-from-bottom"
            animate.leave="anim-fade-to-top"
            [style.animation-delay.ms]="(step() > 0 ? 500 : 0) + 100 * $index"
          >
            @if (_state.type === 'READING' && _state.index === $index) {
              <rid-fog [density]="5" [stagger]="pace()" class="size-full" animate.enter="wait-250 anim-fade-in" />
            }
          </rid-sentence>
        }
      </div>
    }

    @if (_state.type === 'ASSESSING') {
      <rid-assessment-toast (assessed)="assessed($event)" />
    }

    <!-- start -->
    @if (_state.type === 'STARTING') {
      <rid-bottom-button content="Start" [animate.enter]="step() > 0 ? 'wait-500' : undefined" (clicked)="start()" />
    }

    <!-- volgende -->
    @if (_state.type === 'REVIEWING') {
      <rid-bottom-button content="Volgende" (clicked)="step() >= sentencess().length - 1 ? finish() : nextStory()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
